export default function serviceDesignExpanders() {
    const links = document.querySelectorAll('[data-expand-link]');

    for (var i = 0; i < links.length; i++) {
        const link = links[i];

        link.addEventListener('click', () => {
            const id = link.getAttribute('data-expand-link');
            const $target = $(`[data-expand-item="${id}"]`);
            const expandAttr = 'data-expanded';

            $target.slideToggle('500', () => {
                if (link.hasAttribute(expandAttr)) {
                    link.removeAttribute(expandAttr);
                } else {
                    link.setAttribute(expandAttr, '');
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/serviceDesignerExpanders.js